import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[mrsoftappsCorrespondenceFormView]'
})
export class CorrespondenceFormDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
